import React, { Component } from 'react';
import { Icon } from 'antd';
import { queryMaterialDocumentListBR } from '@api/administrative/material';
import { queryFilePreview } from '@api/pub/attachment';

class DescDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      descFile: {},
    };
  }

  componentDidMount() {
    this.getDocumentList();
  }

  // 获取说明性文件
  getDocumentList = () => {
    const params = {
      condition: '费用类型_帮实_desc',
    };
    queryMaterialDocumentListBR(params).then(res => {
      if (res.statusCode === 200 && res.data.length > 0) {
        this.setState({
          descFile: res.data[0].files[0],
        });
      }
    });
  };

  render() {
    const { descFile } = this.state;
    return (
      <span key={descFile.url}>
        <a onClick={() => queryFilePreview(descFile)}>
          <Icon type="question-circle" />
        </a>
      </span>
    );
  }
}

export default DescDoc;



// WEBPACK FOOTER //
// ./src/components/finance/comm/showDescDoc.js